
import React, { useEffect, useState } from 'react'

import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { useNavigate } from 'react-router-dom'

import * as searchSerivce from '@kolayyolla/common/services/searchService'
import { useDebounce } from '@kolayyolla/shared/customHooks'

import { FastfoodOutlined, Search, StoreMallDirectoryOutlined } from '@mui/icons-material'
import { OutlinedInput, InputAdornment, Typography, CircularProgress, Popper, useMediaQuery, Autocomplete, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { makeStyles } from '@mui/styles'

// import 'antd/dist/antd.css'

const useStyles = makeStyles((theme) => {
  const classList = {
    searchBox: {
      width: '100%',
      maxHeight: 35,
      marginBottom: 4,
      borderRadius: '32px!important',
      backgroundColor: theme.palette.background.paper
    },
    searchBoxInput: {
    },

    icon: {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(2)
    },
    popperOvveride: {
      innerHeight: '50vh'
    }
  }
  return classList
})

const SearchBox = ({ userLocation, limitWidth }) => {
  const classes       = useStyles()
  const navigate      = useNavigate()
  const isSmallScreen = useMediaQuery((t) => t.breakpoints.down('sm'))

  const [value, setValue]           = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [options, setOptions]       = useState([])
  const [loading, setLoading]       = useState(false)

  const debouncedQuery = useDebounce(inputValue, 400)

  useEffect(() => {
    if (inputValue === '') {
      setOptions(value ? [value] : [])
      return undefined
    }
    handleSearch(inputValue)

    return null
  }, [debouncedQuery])

  const handleSearch = (searchValue) => {
    setLoading(true)
    searchSerivce.GetSuggestions({
      q: searchValue,
      h3Index: userLocation?.h3Index
    }).then((result) => {
      setLoading(false)
      setOptions(generateOptions(result))
    })
  }

  const generateOptions = (result) => {
    return [...result.venues.map((v) => ({ data: v, type: 'venue', typeTitle: 'İşletmeler' })),
      ...result.products.map((p) => ({ data: p, type: 'product', typeTitle: 'Ürünler' }))]
  }

  const handleSelect = (selectValue) => {
    if (selectValue.type === 'venue') navigate(`/${selectValue.data.alias}`)
    else navigate(`/?q=${selectValue.data.name}`)
  }

  const CustomPopper = (props) => {
    return (
      <Popper {...props}
        style={{
          width: isSmallScreen ? '100vw' : 500,
          transform: 'translate3d(0px,0px,0px)!important'
        }}
        placement={isSmallScreen ? 'bottom-start' : 'bottom-end'} />)
  }
  return (

    <Autocomplete
      id="searchBox"
      ListboxProps={{ style: { minHeight: '70vh', width: 700, minWidth: 500 } }}
      PopperComponent={CustomPopper}
      size="small"
      filterOptions={(x) => x}
      options={options}
      loading={loading}
      loadingText="Aranıyor..."
      autoComplete
      includeInputInList
      filterSelectedOptions
      noOptionsText={inputValue !== '' ? 'Sonuç Bulunamadı' : 'Aramaya başlayın'}
      value={value}
      limitTags={20}
      style={{ flexGrow: 1, textAlign: 'right' }}
      classes={{
        popper: classes.popperOvveride
      }}
      getOptionLabel={(option) => (typeof option === 'string' ? '' : '')}
      onChange={(event, newValue) => {
        setValue(newValue)
        handleSelect(newValue)
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue)
      }}
      groupBy={(option) => option.typeTitle}
      renderInput={(params) => {
        return (
          <OutlinedInput
            id={params.id}
            inputProps={params.inputProps}
            size={params.size}
            ref={params.InputProps.ref}
            classes={
              {
                root: classes.searchBox
              }
            }
            style={{ maxWidth: limitWidth ? 300 : null }}
            placeholder="Arama"
            fullWidth={!limitWidth}
            endAdornment={(
              <InputAdornment position="end">
                {loading ? <CircularProgress color="inherit" size={20} /> : <Search color="primary" />}
              </InputAdornment>
            )}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                navigate(`/?q=${e.target.value}`)
              }
            }}
          />
        )
      }}
      renderOption={(props, option) => {
        try {
          const nameMatches = option.data?.name ? match(option.data?.name, inputValue) : null
          const nameParts   = option.data?.name ? parse(option.data?.name, nameMatches) : null
          const descMatches = option.data?.description ? match(option.data?.description, inputValue) : null
          const descParts   = option.data?.description ? parse(option.data?.description, descMatches) : null

          return (
            <ListItem dense sx={{ width: '100vw', maxWidth: 500, cursor: 'pointer' }} onClick={() => handleSelect(option)}  >
              <ListItemIcon>
                {
                  option.type === 'product'
                    ? <FastfoodOutlined />
                    : <StoreMallDirectoryOutlined />
                }
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Typography>
                    {nameParts.map((part) => (
                      <span key={part.text} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                        {part.text}
                      </span>
                    ))}
                  </Typography>
                )}
                secondary={option.type === 'product'
                  ? descParts.map((part) => (
                    <span key={part.text} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                      {part.text}
                    </span>
                  ))
                  : null}
              />
            </ListItem>
          )
        } catch (e) {
          return null
        }
      }}
    />

  )
}

SearchBox.propTypes    = {}
SearchBox.defaultProps = {  limitWidth: false }

export default SearchBox
